import { Color, Columns, CustomSpacing } from '@genially/public-web-components';

import type { FC } from 'react';
import { ParagraphButton } from 'components/ParagraphButton';
import { ParagraphIcon } from 'components/ParagraphIcon';
import { ParagraphMedia } from 'components/ParagraphMedia';
import { ParagraphParagraph } from 'components/ParagraphParagraph';
import { ParagraphSection } from 'components/ParagraphSection';
import { parseBackground } from 'core/infrastructure/parseBackground';
import { parseLangPath } from 'core/infrastructure/parseLangPath';
export interface BackgroundDTO {
  backgroundType: 'image' | 'video';
  baseColor: {
    color: Color;
  };
  image?: {
    desktop?: ImageSource;
    laptop?: ImageSource;
    tablet?: ImageSource;
    mobile?: ImageSource;
  };
}

interface ImageSource {
  src: string;
}

interface ParagraphColumnsProps {
  behaviorSettings?: {
    rowStyle: {
      background: BackgroundDTO;
      spacing: CustomSpacing;
      general: any;
      borders: any;
      hovers?: any;
    };
    layout_paragraphs: { layout: string; config: any };
  };
  children?: any;
  link?: { url: { path: string } };
}
// export interface Paragraph {
//   type: keyof typeof paragraphsMap;
//   content: any;
//   uuid: string;
// }

export const ParagraphColumns: FC<ParagraphColumnsProps> = ({
  behaviorSettings,
  link,
  children,
}) => {
  return (
    <Columns
      layout={behaviorSettings?.layout_paragraphs.layout}
      layoutType={behaviorSettings?.layout_paragraphs.config.column_widths}
      background={parseBackground(behaviorSettings?.rowStyle?.background)}
      customSpacing={behaviorSettings?.rowStyle.spacing}
      borders={behaviorSettings?.rowStyle.borders}
      general={behaviorSettings?.rowStyle.general}
      hovers={behaviorSettings?.rowStyle.hovers}
      link={link ? parseLangPath(link.url.path) : undefined}
    >
      {children &&
        children.map((paragraph: any, index: number) => {
          if (paragraph.type === 'ParagraphSection') {
            return <ParagraphSection key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphIcon') {
            return <ParagraphIcon key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphParagraph') {
            return <ParagraphParagraph key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphButton') {
            return <ParagraphButton key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphMedia') {
            return <ParagraphMedia key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphColumns') {
            return <ParagraphColumns key={index} {...paragraph.content} />;
          }
          // const Element = paragraphsMap[paragraph.type] || paragraphsMap.default;
          // return <Element key={index} first={index === 0} {...paragraph.content} langcode={'en'} />;
        })}
    </Columns>
  );
};

// const paragraphsMap: Record<string, any> = {
//   ParagraphParagraph,
//   ParagraphIcon,
//   ParagraphMedia,
//   ParagraphColumns,
//   ParagraphButton,
//   ParagraphSection,
//   default: (paragraph: Paragraph) => `No component in paragraphsMap for ${paragraph.type}`,
// };
